import { UUID } from "crypto";
import type {
  StockValueFilters,
  ReturnAnalysisFilters,
  BatchQuantityFilters,
  InventoryTurnoverFilters,
} from "@/app/api/reports/client";

export const reportKeys = {
  all: ["reports"] as const,

  // Stock value reports
  stockValue: () => [...reportKeys.all, "stock-value"] as const,
  stockValueWithFilters: (filters?: StockValueFilters) =>
    [...reportKeys.stockValue(), filters] as const,

  // Stock-specific reports
  stockReports: (stockId: UUID) =>
    [...reportKeys.all, "stock", stockId] as const,
  stockQuantity: (stockId: UUID) =>
    [...reportKeys.stockReports(stockId), "quantity"] as const,
  stockProvisional: (stockId: UUID) =>
    [...reportKeys.stockReports(stockId), "provisional"] as const,
  stockAtDate: (stockId: UUID, targetDate: string) =>
    [...reportKeys.stockReports(stockId), "at-date", targetDate] as const,
  stockTrajectory: (stockId: UUID) =>
    [...reportKeys.stockReports(stockId), "trajectory"] as const,
  stockPending: (stockId: UUID) =>
    [...reportKeys.stockReports(stockId), "pending"] as const,
  stockProjection: (stockId: UUID, startDate: string, endDate: string) =>
    [
      ...reportKeys.stockReports(stockId),
      "projection",
      startDate,
      endDate,
    ] as const,

  // Snapshots
  snapshots: () => [...reportKeys.all, "snapshots"] as const,

  // Flow chain
  flowChain: (flowId: UUID) =>
    [...reportKeys.all, "flow-chain", flowId] as const,

  // Return analysis
  returnAnalysis: () => [...reportKeys.all, "return-analysis"] as const,
  returnAnalysisWithFilters: (filters?: ReturnAnalysisFilters) =>
    [...reportKeys.returnAnalysis(), filters] as const,

  // Batch stock quantities
  batchQuantities: () => [...reportKeys.all, "batch-quantities"] as const,
  batchQuantitiesWithFilters: (filters?: BatchQuantityFilters) =>
    [...reportKeys.batchQuantities(), filters] as const,

  // Inventory turnover
  inventoryTurnover: () => [...reportKeys.all, "inventory-turnover"] as const,
  inventoryTurnoverWithFilters: (filters: InventoryTurnoverFilters) =>
    [...reportKeys.inventoryTurnover(), filters] as const,
};
